import React from 'react';
import './PercentageBox.css';

import { ReactComponent as UpIcon } from '../../assets/icons/up.svg';
import { ReactComponent as DownIcon } from '../../assets/icons/down.svg';
import { ReactComponent as RightIcon } from '../../assets/icons/right.svg';

const PercentageBox = ({percentage, red, bot = false}) => {
  const getTone = () => {
    if (percentage === null || percentage === 0) {
      return {
        iconColor: 'var(--text-contrast-mid)',
        textColor: 'var(--text-contrast-mid)',
        boxClass: 'gray-percentage-box',
      };
    }

    if (red) {
      return {
        iconColor: 'var(--warning)',
        textColor: 'var(--warning)',
        boxClass: 'red-percentage-box',
      };
    }

    if (bot) {
      const botTrendIsGood = percentage < 0;
      return botTrendIsGood
        ? {
            iconColor: 'var(--primary)',
            textColor: 'var(--primary)',
            boxClass: 'blue-percentage-box',
          }
        : {
            iconColor: 'var(--bot)',
            textColor: 'var(--bot)',
            boxClass: 'orange-percentage-box',
          };
    }

    return {
      iconColor: 'var(--primary)',
      textColor: 'var(--primary)',
      boxClass: 'blue-percentage-box',
    };
  };

  let percentageDisplay;
  const clampedPercentage = percentage !== null && percentage > 100000 ? 100000 : percentage;

  const formatNumberWithSign = (number, decimals = 2) => {
    const absFormatted = Math.abs(number).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });

    const sign = number > 0 ? '+' : number < 0 ? '-' : '';
    return `${sign}${absFormatted}%`;
  }

  if (percentage === null) {
    percentageDisplay = 'N/A';
  }
  else {
    const postFix = percentage > 100000 ? '+' : '';

    const decimals = Math.abs(clampedPercentage) > 100 ? 0 : 2;
    percentageDisplay = formatNumberWithSign(clampedPercentage, decimals) + postFix;
  }

  const { iconColor, textColor, boxClass } = getTone();
  let icon;

  if (percentage === null || percentage === 0) {
    icon = <RightIcon className='icon sm percentage-box__icon' />
  }
  else if (percentage > 0) {
    icon = <UpIcon className='icon sm percentage-box__icon' />
  }
  else {
    icon = <DownIcon className='icon sm percentage-box__icon' />
  }

  return (
    <div
      className={`${boxClass} percentage-box`}
      style={{
        '--percentage-icon-color': iconColor,
        '--percentage-text-color': textColor,
      }}
    >
      {icon}
      <span className="percentage-box__value">
        {percentageDisplay}
      </span>
    </div>
  );
}

export default PercentageBox;
